import { Add } from "@mui/icons-material";
import { Box, Button, Container, Tab } from "@mui/material";
import React, { useState } from "react";
import HistoryEntity from "./HistoryEntity";
import PendingEntity from "./PendingEntity";
import ViewEntity from "./ViewEntity";
import HeaderHelpPage from "../HeaderHelpPage";
import { writeLog } from "../../services/services";
import TabsMenu from "../TabsMenu";
import { TabPanel } from "@mui/lab";
import CreateNewBusinessEntity from "../../pages/Admin/CreateNewBusinessEntity";
import { styles } from "../../utils/styles";

const EntitySwitchView = ({ userRole }) => {
  const [selectedView, setSelectedView] = useState("All");
  const [createDialog, setCreateDialog] = useState(false);

  const handleChange = (event, value) => {
    setSelectedView(value);
  };
  return (
    <Container>
      <HeaderHelpPage title="Business Entity" description="Allow Oxygen7 user to manage a business organization or entity acquired." />
      <TabsMenu value={selectedView} onChange={handleChange}>
        <Tab label="All" value="All" />
        <Tab label="Pending" value="Pending" />
        <Tab label="History" value="History" />
        {userRole.includes("Add") &&
          selectedView === "All" && (
            <Box>
              <Button
                variant="contained"
                onClick={() => {
                  writeLog('[Info] - Click button [Add new business entity] - Open new tab to Create A New Business Entity')
                  setCreateDialog(true);
                }}
                startIcon={<Add />}
                sx={{ ...styles.customButton }}
              >
                Add New Business Entity
              </Button>
            </Box>
          )}
        
        <TabPanel value="All">
          <ViewEntity userRole={userRole} />
        </TabPanel>
        <TabPanel value="Pending">
          <PendingEntity userRole={userRole} />
        </TabPanel>
        <TabPanel value="History">
          <HistoryEntity userRole={userRole} />
        </TabPanel>
      </TabsMenu>

      {createDialog && <CreateNewBusinessEntity open={true} onClose={() => setCreateDialog(false)} />}
    </Container>
  );
};

export default EntitySwitchView;
